import { render, staticRenderFns } from "./LeaderboardRankings.vue?vue&type=template&id=4a092611&"
import script from "./LeaderboardRankings.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardRankings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LeaderboardRankings.vue"
export default component.exports